import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import ManualIncidence from 'modules/bookkeepers/store/models/ManualIncidence'
import type ManualIncidenceForm from 'modules/payroll_bundle/pages/IncidencesPage/utils/manualIncidenceForm'

const useFetchManualIncidence = (
  manualIncidenceId: number | string,
  form: ManualIncidenceForm,
  handleClose: () => void
) => {
  const manualIncidence = new ManualIncidence({ id: manualIncidenceId })

  const { loading } = useAsyncData(async () => {
    try {
      await manualIncidence.fetch()
      form.setValues(manualIncidence.toJS())
    } catch {
      handleClose()
    }
  }, [])

  return {
    loading,
    manualIncidence,
  }
}

export default useFetchManualIncidence
